import { render, staticRenderFns } from "./HandSmallSecond.vue?vue&type=template&id=389a418c&"
import script from "./HandSmallSecond.vue?vue&type=script&lang=js&"
export * from "./HandSmallSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HandSmallSecond.vue"
export default component.exports